module.exports = __webpack_public_path__ + "img/royal_assassin_small.32304d5a.png";